import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useTableSearchState } from '@/hooks/useTableSearchState';

type StudiosCatalogSearchContextValue = {
  searchInput: string;
  setSearchInput: (value: string) => void;
  debouncedSearch: string;
  clearSearch: () => void;
};

const StudiosCatalogSearchContext = createContext<StudiosCatalogSearchContextValue | null>(null);

export function StudiosCatalogSearchProvider({ children }: { children: ReactNode }) {
  const { searchInput, setSearchInput, debouncedSearch, clearSearch } = useTableSearchState();

  const value = useMemo(
    () => ({
      searchInput,
      setSearchInput,
      debouncedSearch,
      clearSearch,
    }),
    [searchInput, setSearchInput, debouncedSearch, clearSearch]
  );

  return (
    <StudiosCatalogSearchContext.Provider value={value}>{children}</StudiosCatalogSearchContext.Provider>
  );
}

export function useStudiosCatalogSearch(): StudiosCatalogSearchContextValue {
  const ctx = useContext(StudiosCatalogSearchContext);
  if (!ctx) {
    throw new Error('useStudiosCatalogSearch must be used within StudiosCatalogSearchProvider');
  }
  return ctx;
}
